<template>
<div class="container wrap ">
  <div v-for="(x, index) in data"
       class="animation-bottom container--unit col-12 col-xl-3 col-lg-4 col-md-6 col-sm-12"
       :class="{ disabled: (!student.teens && ((x._id != unit._id) && !x.finished)) || !x.ead }"
       :style="{animationDelay: (index / 10) + 's'}"
       :key="index"
       @click="goToUnit(x)">

    <!-- <div class="container--unit__box" :style="{borderColor: x.cor2}"> -->
    <div class="container--unit__box">

      <!-- <div class="container--unit__box-translate"> -->

        <div class="container--unit__ball container" :style="{background: 'linear-gradient(-45deg,' + x.cor1 + ' 0% , ' + x.cor2 + ') 100% '}">
          <span class="span-unit">unit</span>
          <h3>{{x.number > 9 ? x.number : `0${x.number}`}}</h3>
        </div>

        <div class="container--unit__star">
          <div>
            <img src="@/assets/img/star-unit.svg" width="30" alt="Minds" :class="{starenable : x.score >= 35}">
            <img src="@/assets/img/star-unit.svg" width="30" alt="Minds" :class="{starenable : x.score >= 70}">
            <img src="@/assets/img/star-unit.svg" width="30" alt="Minds" :class="{starenable : x.score >= 90}">
          </div>
        </div>

        <div class="container--unit__title">
          <!-- BASIC -->
          <!-- {{x.title}} -->
        </div>

        <div class="container--unit__btn container align-items-center justify-content-center">

          <div v-if="x.ead">

            <div v-if="x.finished">
              <button type="button" class="btn btn-rounded color-dark btn-sm gradient-finished" name="button">{{ isReview ? 'REVIEW' : 'FINISHED' }}</button>
            </div>

            <div v-else-if="!x.finished && !started(x)">
              <button type="button" class="btn btn-rounded color-white btn-sm gradient-start" name="button">START</button>
            </div>

            <div v-else-if="started(x) && !x.finished">
              <button type="button" class="btn btn-rounded color-white btn-sm gradient-start" name="button">CONTINUAR</button>
            </div>

          </div>

          <div v-else>
            <button type="button" class="btn btn-rounded color-white btn-sm gradient-presencial" name="button">PRESENCIAL</button>
          </div>

        </div>

      <!-- </div> -->

    </div>

    <div class="container--unit__cover" v-if="isReview && ((x.ead && !x.finished) || !x.ead)">
    <!-- <div class="container--unit__cover" v-if="true"> -->
      <font-awesome-icon icon="ban"/>
      <p>BLOCKED</p>
    </div>

  </div>

  <div class="container align-items-center justify-content-center width-full padding-top-20 animation-fade animation-delay-1">
    <!-- <el-pagination layout="prev, pager, next" :total="20" /> -->
  </div>

</div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'unidades',
  props: {
    data: {
      type: Array
    }
  },
  computed: {
    ...mapGetters({
      unit: 'unit/get',
      isReview: 'isReview',
      student: 'student/GET'
    }),

  },
  methods: {
    async goToUnit (unit) {
      if (unit.ead) {
        if (!this.isReview && !this.student.teens) {
          if ((unit._id == this.unit._id) || unit.finished) {
            await this.$store.dispatch('unit/fetchUnit', { key: unit._id, review: false })
            this.$router.push({ name: this.isReview ? 'unit-review' : 'unit', params: { unit: unit.number.toString() } })
          }
        } else if (!!this.student.teens) {
          try {
            await this.$store.dispatch('teens/sethUnit', unit._id)
            this.$router.push({ name: 'unit', params: { unit: unit.number.toString() } })
          } catch (e) {
            console.warn(e);
          }
        } else {
          if (unit.finished) {
            try {
              await this.$store.dispatch('unit/fetchUnit', { key: unit._id, review: false })
              this.$router.push({ name: this.isReview ? 'unit-review' : 'unit', params: { unit: unit.number.toString() } })
            } catch (e) {
              console.warn(e);
            }
          }
        }
      }
    },
    started (unit) {
      if (!unit)
        return false

      for (const key in unit.topics) {
        if (unit.topics[key].finished) {
          return true
        } else {
          for (const s_key in unit.topics[key].subTopics) {
            if (unit.topics[key].subTopics[s_key].finished) {
              return true
            } else {
              if (unit.topics[key].subTopics[s_key].exercise) {
                const questions = unit.topics[key].subTopics[s_key].exercise ? unit.topics[key].subTopics[s_key].exercise.questions : []

                for (const q_key in questions) {
                  if (unit.topics[key].subTopics[s_key].exercise.questions[q_key].answered) return true
                }
              }
            }
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.starenable {
    filter: grayscale(0%)!important;
}
.presential {
    background: #00C6FF;
    background: -webkit-gradient(linear, right top, left top, from(#00C6FF), color-stop(73%, #035BCD), to(#0435BB));
    background: linear-gradient(-90deg, #00C6FF 0%, #035BCD 73%, #0435BB 100%);
}
.container--unit {
    padding: 7px 13px;
    box-sizing: border-box;
    margin-top: 25px;
    position: relative;
    .container--unit__box {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08), 0 6px 7px 0 rgba(0,0,0,0.04);
        border-radius: 20px;
        box-sizing: border-box;
        border: 2px solid rgb(82, 82, 82);
        text-align: center;
        transition: 0.3s;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
            transform: scale(1.06);
            background: #dfdfdf;
            box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);
        }
        .container--unit__title {
            font-size: 14px;
            text-align: center;
            color: #717171;
        }
        .container--unit__star {
            margin: 10px 0px;
            img {
                filter: grayscale(100%);
                margin-left: 5px;
            }
        }
        .container--unit__btn {
            margin: 5px 0px 10px 0px;
        }
        .container--unit__ball {
            width: 105px;
            height: 55px;
            margin-top: -20px;
            border-radius: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            text-align: center;
            // margin: 0 auto;
            // flex-direction: column;
            // position: relative;
            span {
                font-size: 15px;
                font-weight: 300
                // position: absolute;
                // top: 8px;
                // left: 0;
                // width: 100%;
                // text-align: center;
            }
            h3 {
                font-size: 40px;
                margin-left: 5px;
                font-weight: 400;
            }
        }
    }
    &__cover {
      cursor: not-allowed;
      position: absolute;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: calc(100% + 40px);
      bottom: 0;
      right: 0;
      flex-direction: column;
      background-color: rgba(#F3F3F3, 0.5);
      &:hover {
        svg {
          width: 85px;
          height: 85px;
          color:#c43232;
          background: rgba(#e84c4c, 0.5);
          padding: 5px;
          border-radius: 50px;
        }
      }
      svg {
        width: 80px;
        height: 80px;
        margin-top: 20px;
        color: #7f7f7f;
        transition: all .2s;
        background: rgba(#F3F3F3, 0.5);
        padding: 5px;
        border-radius: 50px;
      }
      p{
        background: #ffffffbf;
        padding: 6px 30px;
        border-radius: 30px;
        color: #e84c4c;
      }
    }
}

.disabled {
  &, & * {
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/units/index.vue